<template>
    <div>
        <div class=" row mb-2">
            <label class="col-sm-4  text-lr lh40"><i
                    v-if=" Data.data.c_priority==='S'"
                    class="fa fa-asterisk text-danger font10 ml-1"
                    aria-hidden="true"></i>{{ Data.data.c_name }}：</label>
            <div class="col-sm-7 "  v-if="Data.data.c_choice.type!=='api'&&Data.data.c_choice.type!=='api-data'">
                <el-checkbox-group v-model="checkList">
                    <el-checkbox :label="value" v-for="(value,index) in Data.data.c_choice.map" :key="index"
                                 @change="clickData(value,Data)"
                    ></el-checkbox>
                </el-checkbox-group>
                {{ Data.data.c_unit }}
            </div>
          <div class="col-sm-7 " v-if="Data.data.c_choice.type==='api'">
            <el-badge :value="list.length" :hidden="list.length===0"  class="item " type="primary">
              <el-dropdown trigger="click" ref="Dropdown" hide-on-click>
                <el-button type="primary" size="small" @click="get_select_data(Data.data)">查看选项<i
                    class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown" style="width: 230px;max-height: 300px;overflow-y: scroll">
                  <el-tree :data="options" :props="defaultProps" ref="tree" class="filter-tree"
                           accordion   show-checkbox v-if="api_tree_flag"
                           :default-checked-keys="checkList" node-key="id"
                           @check-change="get_tree_data($event,Data)">
                  </el-tree>
                </el-dropdown-menu>
              </el-dropdown>
            </el-badge>
          </div>
<!--          新建、编辑功能组时-->
          <div class="col-sm-7 " v-if="Data.data.c_choice.type==='api-data'">
            <el-badge :value="list.length" :hidden="list.length===0"  class="item " type="primary">
              <el-dropdown trigger="click" ref="Dropdown2">
                <el-button type="primary" size="small" @click="get_api_data(Data.data)">查看选项<i
                  class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown" style="min-width: 300px;max-height: 400px;overflow-y: scroll">
                  <el-tree :data="api_options" :show-checkbox="true" v-if="api_tree_flag"
                          node-key="id" :props="defaultProps"
                           :default-checked-keys="checkList"   @check-change="get_tree_data"
                           ref="tree" class="filter-tree" accordion
                  ></el-tree>
                </el-dropdown-menu>
              </el-dropdown>
            </el-badge>

          </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "checkbox",
    props: [
        'Data'
    ],
    data() {
        return {
            checkList: [],
            formLabelWidth: '200px',
          defaultProps: {
            children: 'children',
            label: 'label',
            id: 'id',
          },

          api_value:'',
          api_options:[],
          list:[],
          name:'',
          api_tree_flag:true,
          options:[],
value:''
        }
    },
    created() {
      // this.checkList =['11-11060726869053440']
      if(this.Data.data.c_choice.type==='api-data'){
          this.checkList = this.Data.data.c_value===null?[]:this.Data.data.c_value
          this.list = this.Data.data.c_value===null?[]:this.Data.data.c_value
        this.get_api_data(this.Data.data)
        }else if(this.Data.data.c_choice.type==='api'){
        this.checkList = this.Data.data.c_value === null ? [] : this.Data.data.c_value
        this.list = this.Data.data.c_value===null?[]:this.Data.data.c_value
      }
      else {
        this.checkList = this.Data.data.c_value === null ? [] : this.Data.data.c_value.split(',')
      }

    },
    methods: {
      get_tree_data(){
        let temp = this.$refs.tree.getCheckedNodes(this.Data.attr.son_only, this.Data.attr.half)
        this.list = temp.map(item => item.id)
        console.log(this.list,'dsf1111')
        this.$get_function(this.Data, this.list)
      },
        //选中值
        clickData(v, Data) {
            console.log(this.checkList)
            let x = this.checkList.join(",")
            this.$get_function(Data, x)
        },
      //获取api——data数据
      get_api_data(obj){
        this.api_tree_flag=false
        console.log(obj)
        this.api_options=[]
        this.$axios({
          method: 'post',
          url: this.IBMS_API + obj.c_choice.map,
          data: {
            "version": "V1.1",
            "data": {
              "id": this.$store.state.funcGroup_data.link_platform,
            }
          }
        }).then((response) => {
          for(let i in response.data.content){
            this.api_options.push({'id':response.data.content[i].project_id,'label':response.data.content[i].project_name})
          }
          this.api_tree_flag=true
        })
      },
      get_select_data(obj){
          if(obj.c_choice.type==='api'){
            this.options=[]
            this.api_tree_flag=false
            this.$axios.post(this.IBMS_API + obj.c_choice.map).then((response) => {
              for(let i in response.data.content){
                this.options.push({'id':response.data.content[i].id,'label':response.data.content[i].name})
              }
              this.api_tree_flag=true
            })
            console.log(this.checkList,'rft344')
          }
      },
    }
}
</script>

<style scoped>

</style>
